(() => {
  if (window.PadNavigation) return;
  const instances = new Map();
  function refreshAboutLinks() {
    const inline = document.body.classList.contains('pad-view-cafe') && document.getElementById('pad-about');
    document.querySelectorAll('[data-pad-about-link]').forEach(link => {
      link.setAttribute('href', inline ? link.dataset.padAboutInline : link.dataset.padAboutLink);
    });
  }
  function mount(el) {
    if (instances.has(el)) return;
    const controller = new AbortController(), signal = controller.signal;
    const listen = (target, name, callback, options = {}) => target?.addEventListener(name, callback, {...options, signal});
    const timers = new Set();
    const later = (fn, ms) => { const id = setTimeout(() => {timers.delete(id);fn();}, ms); timers.add(id); return id; };
    const menu = el.querySelector('[data-pad-nav-menu]'), toggle = el.querySelector('[data-pad-nav-toggle]'), links = el.querySelector('[data-pad-nav-links]');
    const desktop = matchMedia('(min-width:1001px)');
    let closeTimer, openTimer;
    function open(state) {
      clearTimeout(closeTimer);clearTimeout(openTimer);
      if(state) menu.style.setProperty('--pad-nav-open-width', `${links.scrollWidth}px`);
      menu.classList.toggle('is-open',state); toggle.setAttribute('aria-expanded',String(state)); links.inert = !state;
    }
    open(false);
    listen(toggle,'click',() => open(toggle.getAttribute('aria-expanded') !== 'true'));
    listen(menu,'pointerenter',event => {if(event.pointerType === 'mouse' && desktop.matches) {clearTimeout(closeTimer);openTimer=later(()=>open(true),180);}});
    listen(menu,'pointerleave',event => {if(event.pointerType !== 'mouse' || !desktop.matches)return;clearTimeout(openTimer);closeTimer = later(() => {if(!menu.contains(document.activeElement)) open(false);},320);});
    // Keep the menu state consistent when the layout switches between its pill
    // and dropdown. Return keyboard focus before making its links inert.
    listen(desktop,'change',() => {if(links.contains(document.activeElement))toggle.focus();open(false);});
    listen(menu,'focusout',() => later(() => {if(!menu.contains(document.activeElement)) open(false);},0));
    // Keep the activated anchor interactive through its native default action.
    // Closing synchronously makes it inert and can cancel browser navigation.
    listen(links,'click',event => {if(event.target.closest('a')) later(() => open(false),0);});
    listen(document,'pointerdown',event => {if(!menu.contains(event.target)) open(false);});
    listen(document,'keydown',event => {if(event.key === 'Escape' && menu.classList.contains('is-open')) {open(false);toggle.focus();}});
    let cartRefresh=0;
    const refreshCount=async()=>{const revision=++cartRefresh;try{const response=await fetch((window.Shopify?.routes?.root||'/')+'cart.js',{credentials:'same-origin',cache:'no-store',signal});if(!response.ok)return;const cart=await response.json();if(revision!==cartRefresh)return;const count=Array.isArray(cart.items)?cart.items.reduce((sum,item)=>sum+(item.properties?._pad_role==='extra'?0:item.quantity),0):cart.item_count;if(Number.isInteger(count))el.querySelectorAll('[data-pad-cart-count]').forEach(node=>node.textContent=count);}catch(_){}};
    listen(document,'pad:cart-changed',refreshCount);refreshCount();
    listen(window,'pageshow',event=>{if(event.persisted)refreshCount();});
    const mark=el.querySelector('[data-pad-nav-poppy]');
    window.PadPoppy?.mount(mark,el.dataset.poppyGif,mark.dataset.stillSrc,signal);
    instances.set(el,() => {controller.abort();timers.forEach(clearTimeout);instances.delete(el);});
  }
  const mountAll = (scope=document) => {if(scope.matches?.('[data-pad-navigation]'))mount(scope);scope.querySelectorAll('[data-pad-navigation]').forEach(mount);};
  window.PadNavigation={mount:mountAll};
  mountAll();
  refreshAboutLinks();
  document.addEventListener('shopify:section:load',event=>{mountAll(event.target);requestAnimationFrame(refreshAboutLinks);});
  document.addEventListener('shopify:section:unload',event=>{for(const [el,dispose] of instances)if(event.target.contains(el))dispose();requestAnimationFrame(refreshAboutLinks);});
})();
